export const firebaseConfig = {
  apiKey: "AIzaSyB4kYcK4ttxuB1xSF-QuOhGEriEkEVd5PI",
  authDomain: "yormungandr-0.firebaseapp.com",
  projectId: "yormungandr-0",
  storageBucket: "yormungandr-0.appspot.com",
  messagingSenderId: "170095123496",
  measurementId: "G-07T7VPTSFC",
  appId: "1:170095123496:web:4e3d83ac6405b28e48e91d"
};
